import type { PlayerTrack } from './player-context'

export type SearchResult = PlayerTrack & { duration?: string; durationSec?: number }

export async function searchYouTube(q: string): Promise<{ items: SearchResult[]; error?: string }> {
  if (!q.trim()) return { items: [] }
  try {
    const r = await fetch(`/api/youtube/search?q=${encodeURIComponent(q)}`)
    const j = await r.json()
    if (!r.ok) return { items: [], error: j.error || 'Erreur de recherche' }
    return { items: j.items || [] }
  } catch (e: any) {
    return { items: [], error: e?.message || 'Réseau indisponible' }
  }
}
